module.exports = __webpack_public_path__ + "static/img/avatar-s-20.32972323.jpg";